"use client";

import { useRef } from "react";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const stories = [{
  area: "SPRAYING SYSTEMS CO.",
  title: "Processador de Aço Elimina o Desperdício de Óleo e Poupa 30.000 USD Anualmente com Novo Sistema de Pulverização",
  summary: "Um processador de aço aplicava óleo em chapas de aço para prevenir a oxidação e otimizar o processamento futuro. Era utilizado um cabeçote de pulverização equipado com bicos de jato plano para aplicar o óleo...",
  partner: "Industria Alimentar",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-29-as-19.02.19.png?v=rrpr5vvzh",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-27-as-19.59.59.png?v=772i45nlbh-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-27-as-19.59.59.png?v=tisq5dmj4cq-wvc-sizes",
  alt: "Sistema de refrigeração industrial com bicos de pulverização em operação"
}, {
  area: "SPRAYING SYSTEMS CO.",
  title: "Sistema de Pulverização AutoJet® Poupa Mais de 200.000 USD Anualmente a Produtor de Aço",
  summary: "Uma panificadora que fornecia pães de hambúrguer a grandes cadeias de fast-food necessitava de aplicar clara de ovo nos pães antes do cozimento para criar um aspeto brilhante...",
  partner: "Industria Alimentar",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-29-as-18.40.57.png?v=iae0bwa63g",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-29-as-18.40.57.png?v=uh8er7rolpd-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-29-as-18.40.57.png?v=49cg95pd1yq-wvc-sizes",
  alt: "Equipamento de lavagem de tanques em ambiente de processamento alimentar"
}, {
  area: "METAIS & AÇOS",
  title: "Produtor de Waffles Poupa 2,2 Milhões de USD Anualmente com Sistema de Pulverização Aquecido AccuCoat®",
  summary: "Uma empresa alimentar necessitava de melhorar o seu método de aplicação de óleo de desmoldagem em máquinas de waffles para garantir a libertação limpa após o cozimento. O sistema então utilizado empregava bicos de atomização por ar que frequentemente aplicavam demasiado ou demasiado pouco óleo de desmoldagem. A sobredosagem de óleo de desmoldagem fazia com que ...",
  partner: "Industria Alimentar",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-29-as-19.05.58.png?v=jotdctoj47d",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-29-as-18.40.42.png?v=5gc8u89ugbt-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-29-as-18.40.42.png?v=e9etgkxfbyi-wvc-sizes",
  alt: "Braço robótico aplicando lubrificante com precisão em peça automóvel"
}, {
  area: "FARMACÊUTICA",
  title: "Controlo de humidade em salas limpas.",
  summary: "Instalação de bicos de atomização a ar para controlo de humidade, mantendo condições ideais para a produção de medicamentos sensíveis.",
  partner: "Industria Alimentar",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/pharmaceutical_humidity.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/pharmaceutical_humidity.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/pharmaceutical_humidity.png-wvc-sizes",
  alt: "Sistema de atomização a ar em ambiente de laboratório farmacêutico"
}, {
  area: "QUÍMICA",
  title: "Processador de Aço Elimina o Desperdício de Óleo e Poupa 30.000 USD Anualmente com Novo Sistema de Pulverização",
  summary: "Um processador de aço aplicava óleo em chapas de aço para prevenir a oxidação e otimizar o processamento futuro. Era utilizado um cabeçote de pulverização equipado com bicos de jato plano para aplicar o óleo...",
  partner: "Química Industrial S.A.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/chemical_coating_process.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/chemical_coating_process.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/chemical_coating_process.png-wvc-sizes",
  alt: "Processo de revestimento químico com bicos de alta pressão"
}, {
  area: "METAIS & AÇOS\xA0",
  title: "Sistema de Pulverização AutoJet® Poupa Mais de 200.000 USD Anualmente a Produtor de Aço",
  summary: "Uma siderurgia aplicava inibidor de corrosão em chapas de aço antes da conformação. Os operadores pulverizavam o fluido à base de solvente com pistolas de pintura manuais. A largura da chapa e a velocidade da linha variavam. Os operadores não conseguiam aplicar de forma consistente o volume adequado de inibidor de corrosão...",
  partner: "AgroCampo Moderno",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-29-as-18.58.37.png?v=v3be7gb7p7t",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-29-as-18.58.37.png?v=yiz45vzp91-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-29-as-18.58.37.png?v=q6udmsdi23k-wvc-sizes",
  alt: "Sistema de pulverização em estufa agrícola de alta tecnologia"
}];
export default function SuccessCaseGrid() {
  const container = useRef<HTMLElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".story-header", {
        y: 24
      });
      gsap.to(".story-header", {
        opacity: 1,
        y: 0,
        duration: 0.64,
        ease: "power3.out",
        stagger: 0.08,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.set(".story-card", {
        y: 24
      });
      gsap.to(".story-card", {
        opacity: 1,
        y: 0,
        duration: 0.64,
        ease: "power3.out",
        stagger: 0.12,
        scrollTrigger: {
          trigger: ".story-grid",
          start: "top 85%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".story-header", ".story-card"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31375" id="successcasegrid" ref={container} data-nav="dark" className="bg-background text-foreground py-24 md:py-44">
      <div className="mx-auto max-w-[1360px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-8">
          <div className="lg:col-span-5 story-header" style={{
          opacity: 0
        }}>
            <p className="text-xs font-medium uppercase mb-6" style={{
            letterSpacing: "0.22em",
            color: "var(--muted-foreground)"
          }}>
              Casos de Sucesso
            </p>
            <h2 className="font-default font-medium leading-[1.06]" style={{
            fontSize: "clamp(2.125rem, 4.6vw, 4rem)",
            letterSpacing: "-0.024em"
          }}>Casos de Sucesso<br />Industria Metais &amp; Aços</h2>
          </div>

          <div className="lg:col-span-7 flex flex-col justify-between gap-8 story-header" style={{
          opacity: 0
        }}>
            <p className="font-default" style={{
            fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
            lineHeight: 1.55,
            letterSpacing: "-0.005em",
            color: "var(--muted-foreground)"
          }}>Seis exemplos de casos de sucesso na industria dos metais e aços onde a Spraying Systems Co. aplicou a sua experiência técnica para otimizar processos industriais, maximizar a eficiência, rendimento e produtividade.</p>
            <div className="flex lg:justify-end">
              <Link to="/ApplicationsPage" className="group inline-flex items-center gap-2 text-foreground transition-colors hover:opacity-80" style={{
              fontSize: "0.9375rem"
            }}>
                <span>Ver todas as aplicações</span>
                <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.25} />
              </Link>
            </div>
          </div>
        </div>

        <div className="story-grid mt-20 md:mt-24 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {stories.map((story, i) => <article key={i} data-index={i} className="story-card group relative flex flex-col overflow-hidden rounded-2xl border transition-all duration-[320ms] hover:-translate-y-1" style={{
          opacity: 0,
          backgroundColor: "var(--card)",
          borderColor: "var(--border)"
        }} onMouseEnter={e => {
          e.currentTarget.style.borderColor = "var(--primary)";
          e.currentTarget.style.boxShadow = "var(--shadow-md)";
        }} onMouseLeave={e => {
          e.currentTarget.style.borderColor = "var(--border)";
          e.currentTarget.style.boxShadow = "none";
        }}>
              <div className="relative overflow-hidden" style={{
            aspectRatio: "16 / 10"
          }}>
                <img src={story.image} data-wvc-srcset={story.srcset} data-wvc-sizes={story.sizes} alt={story.alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
                <div className="absolute inset-0 pointer-events-none" style={{
              background: "linear-gradient(180deg, hsl(215 80% 20% / 0.2) 0%, hsl(215 80% 20% / 0.05) 40%, hsl(215 80% 20% / 0.4) 100%)"
            }} />
                <span className="absolute top-6 left-6 text-xs font-medium uppercase" style={{
              letterSpacing: "0.22em",
              color: "var(--primary-foreground)"
            }}>
                  {story.area}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-6 md:p-8">
                <h3 className="font-default font-medium mb-4" style={{
              fontSize: "clamp(1.25rem, 1.8vw, 1.5rem)",
              lineHeight: 1.2,
              letterSpacing: "-0.018em"
            }}>
                  {story.title}
                </h3>
                <p className="font-default flex-1" style={{
              fontSize: "0.9375rem",
              lineHeight: 1.6,
              color: "var(--muted-foreground)"
            }}>
                  {story.summary}
                </p>

                <div className="mt-8 pt-6 flex items-center justify-between gap-4 border-t" style={{
              borderColor: "var(--border)"
            }}>
                  <span className="text-sm font-semibold" style={{
                color: "var(--foreground)"
              }}>
                    {story.partner}
                  </span>
                  <Button asChild variant="ghost" size="sm" className="h-auto px-2 py-1 gap-1.5 bg-transparent hover:bg-transparent text-primary hover:text-primary">
                    <Link to="/ApplicationsPage" className="group/link inline-flex items-center">
                      <span>Ler caso</span>
                      <ArrowUpRight className="size-4 transition-transform duration-300 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" strokeWidth={1.25} />
                    </Link>
                  </Button>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}